import { maxBy } from "lodash-es";

import { createAppSelector, publicationSelectors } from "./base";
import { selectCurrentSection } from "./current";

import { isLinkedSection, isTemplateSection } from "utils/publishing";

// If the current section is a template section, return its own section ID.
// If the current section is a linked section, return the template section ID.
// Otherwise, return null.
export const selectTemplateSectionIdForCurrentSection = createAppSelector(
  [selectCurrentSection],
  (section) => {
    if (!section) return null;

    return isLinkedSection(section)
      ? section.template_id
      : isTemplateSection(section)
        ? section.id
        : null;
  },
);

export const selectLatestPublicationForCurrentSection = createAppSelector(
  [
    (state) =>
      publicationSelectors.filterBySectionId(
        state,
        selectTemplateSectionIdForCurrentSection(state),
      ),
  ],
  (publications) => maxBy(publications, "version"),
);

export const selectLatestPublicationForSectionId = createAppSelector(
  [publicationSelectors.filterBySectionId],
  (publications) => maxBy(publications, "version"),
);
